module.exports = __webpack_public_path__ + "static/media/first_floor.c287374c.JPG";